import { Component, Vue } from "vue-property-decorator";

@Component
export default class IBMobileDetector extends Vue {

	get isMobileDevice(): boolean {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
			.test(navigator.userAgent);
	}

}